import { render } from "./DrugInfomation.vue?vue&type=template&id=2e3da894"
import script from "./DrugInfomation.vue?vue&type=script&lang=js"
export * from "./DrugInfomation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pharmarcy/DrugInfomation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e3da894"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e3da894', __exports__)) {
    api.reload('2e3da894', __exports__)
  }
  
  module.hot.accept("./DrugInfomation.vue?vue&type=template&id=2e3da894", () => {
    api.rerender('2e3da894', render)
  })

}


export default __exports__